import { AVAILABLE_LOCALES } from '@src/util/constants'

export default class Category {

  id: number
  categoryName: CategoryLanguages
  workoutsCount?: number

  constructor (attributes?) {
    Object.assign(this, attributes)
  }

  getName (language: string): string {
    // Prefer exact language, else fallback to first non-empty from AVAILABLE_LOCALES
    const current = this.categoryName && this.categoryName[language]
    if (current && current.trim().length) return current

    for (const locale of AVAILABLE_LOCALES) {
      const value = this.categoryName ? this.categoryName[locale] : ''
      if (value && value.trim().length) return value
    }
    if (this.categoryName) {
      for (const key of Object.keys(this.categoryName)) {
        const value = this.categoryName[key]
        if (value && value.trim().length) return value
      }
    }
    return ''
  }
}

export class CategoryLanguages {
  [locale: string]: string

  constructor (attributes?) {
    Object.assign(this, attributes)
  }
}
